import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util from '@/libs/util';
import { mapState } from 'vuex';
export default {
  props: ['orderDetail'],
  data: function data() {
    return {
      layer: {
        show: false,
        title: '备注信息',
        showButton: true,
        form: {},
        width: '600px'
      }
    };
  },
  watch: {
    orderDetail: {
      handler: function handler(val) {
        this.layer.form = {
          storeRemark: val.storeRemark,
          orderId: val.orderId,
          storeRemarkLevel: val.storeRemarkLevel
        };
      },
      deep: true
    }
  },
  computed: _objectSpread({}, mapState('d2admin', {
    menu: function menu(state) {
      return state.permission.routeKey;
    }
  })),
  methods: {
    isShow: function isShow(auto) {
      return this.isBtnGroud(this.menu, auto);
    },
    confirm: function confirm() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.remark(_this.layer.form);

              case 2:
                _this.$notify.success({
                  title: '成功',
                  message: '成功'
                });

                _this.layer.show = false;
                _this.orderDetail.storeRemark = _this.layer.form.storeRemark;
                _this.orderDetail.storeRemarkLevel = _this.layer.form.storeRemarkLevel;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    copyThat: function copyThat() {
      util.copyThat(this.orderDetail.orderNo);
    }
  }
};